import { Types, nameSpace } from '@/store/modules/authTypes'
import { Types as indexTypes } from '@/store/indexTypes'

import { checkUserAccess, getLogout } from '@/api/auth-routes'
import { removeNamespace } from '@/helper/namespace-helper'
import { removeAccessToken, getAccessToken, setAccountId } from '@/helper/auth-helper'

const _types = removeNamespace(nameSpace, Types)

const defaultState = () => ({
    user: null,
    accountId: null,
    timezoneId: null,
    permissions: [],
    logoutRedirect: false,
    redirectForbidden: false,
    appVersionChanged: false,
})

const state = defaultState()

const getters = {
    [_types.getters.GET_USER_NAME]: state => !!state.user ? state.user.name : 'User',
    [_types.getters.IS_ADMIN]: state => !!state.user ? !!state.user['is_admin'] : false,
}

const mutations = {
    [_types.mutations.SET_ACCOUNT_ID](state, accountId) {
        state.accountId = accountId
    },

    [_types.mutations.SET_ACCOUNT_PERMISSION](state, permissions) {
        state.permissions = permissions
    },

    [_types.mutations.SET_USER](state, user) {
        state.user = user
    },

    [_types.mutations.REDIRECT_FORBIDDEN](state, redirect) {
        state.redirectForbidden = redirect
    },

    [_types.mutations.APP_VERSION_CHANGED](state, value) {
        state.appVersionChanged = value
    },

    [_types.mutations.RESET_STATE](state) {
        state = Object.assign(state, defaultState())
    },
}

const actions = {
    async [_types.actions.GET_CHECK]({ commit }) {
        const { success, payload, message } = await checkUserAccess()

        if (success) {
            commit(_types.mutations.SET_USER, payload.user)
            commit(_types.mutations.SET_ACCOUNT_PERMISSION, payload.permissions)
            commit(_types.mutations.SET_ACCOUNT_ID, payload.account.slug)
            setAccountId(payload.account.slug)
        } else {
            !!message && commit(indexTypes.mutations.SET_MESSAGE, { message, type: 'error-bg' }, { root: true })

            removeAccessToken()
        }
    },

    async [_types.actions.LOG_OUT]({ commit }) {
        if (!!getAccessToken()) {
            const { success, message } = await getLogout()

            if (success) {
                !!message && commit(indexTypes.mutations.SET_MESSAGE, { message, type: 'success-bg' }, { root: true })
            }
        }
        commit(_types.mutations.RESET_STATE)
        removeAccessToken()
    },

    async [_types.actions.REMOVE_ACCOUNT_DATA]({ commit }) {
        commit(_types.mutations.RESET_STATE)
        removeAccessToken()
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}
